import AddSeat from "/@/views/Seat/components/addSeat.vue";

export default {
  router: {
    login: {
      title: "Cross-border Customer Service Cloud Assistant",
      text01:
        "Two-way real-time translation display, multiple translation routes",
      text02: "Supports 200+ languages ​​worldwide",
      text03:
        "Chatgpt, Deepl, the smartest and most accurate translation service",
      text04:
        "Fingerprint browser on mobile phone simulates login, easily realize multiple accounts on one device",
      text05: "User tags, precise management, precise marketing, all in one go",
      text06:
        "Independent conversation translation settings, easy chatting with friends from different countries;",
      useName: "Account Login",
      placeholder01: "Please enter the seat account",
      placeholder02: "Please enter your password",
      loginText: "Login",
      loginSuccess: "Login successful",
      protocol: "Privacy Agreement",
    },
    head: {
      portNumber: "portNumber ",
      timeRemaining: "time left",
      day: "day",
      Due: "Expired, please renew in time",
      expirationDate: "Date of Expiry",
      service: "Contact Customer Service",
      help: "help",
      logout: "Log out",
    },
    menu: {
      chat: "Social media account chat",
      seat: "Customer service",
    },
    status: {
      all: "All",
      Online: "Online",
      Offline: "Offline",
      invoke: "Enable",
      disabled: "Disable",
    },
    chat: {
      tableFields01: "Account",
      tableFields02: "Social Media Platform",
      tableFields03: "Online Status",
      tableFields04: "Attribution seat (remarks)",
      tableFields05: "Avatar",
      tableFields06: "NickName",
      tableFields07: "Creation time",
      tableFields08: "Bind seat",
      tableFields09: "Account Log",
      socialAccounts: "Social media accounts",
      socialAccountsName: "Social media account nickname",
      addAccount: "Add social media accounts",
      updateSeat: "Change seat",
      bindSeat: "Bind seat",
      forcedOffline: "Forced offline",
      delAccount: "Account Deletion",
      login: "Login",
      accountLog01: "Real-time logging",
      accountLog02: "current",
      accountLog03: "Records, up to 100 records are displayed",
      qrCodeTitle: "Click to reload the QR code",
      phone: "Use phone number to link",
      verify01: "Seat customer service cannot be empty",
      accountConnection: "Account connecting",
    },
    seat: {
      title: "Agent Management",
      addSeatButton: "Add seats",
      editSeatButton: "Edit Seat",
      tableText01: "Agent Account",
      tableText02: "Social media accounts assigned",
      tableText03: "Online Status",
      tableText04: "Account Status",
      tableText05: "Remark",
      tableText06: "Add time",
      tableText07: "Seat password",
      bindSocialMediaAccount: "Link social media accounts",
      automatic: "Automatically generated after submission",
      seatPassword: "Agent password",
      enable: "Is it enabled?",
      placeholder01: "Please enter your account number",
      placeholder02: "Please enter a comment",
      placeholder03: "Please enter your password",
      passwordVerification: "Password cannot be empty",
      passwordLengthVerification:
        "The minimum password length cannot be less than 4 and the maximum password length cannot be greater than 10",
      selectAccount: "Select Account",
    },
    public: {
      inputText: "Please enter",
      selsectText: "Please select",
      query: "Query",
      reset: "Reset",
      check: "Check",
      operate: "Operate",
      status: "Status",
      edit: "Edit",
      confirm: "Sure",
      cancel: "Cancel",
    },
    message: {
      delTitle: "Deleting a tag",
      delHint: "Are you sure you want to delete?",
      delSuccess: "Deleted successfully",
      editSuccess: "Edit Success",
      addSuccess: "Create Success",
      acountEmptyWarning: "Account cannot be empty",
      accountAlreadyExistsAndOnline:
        "Login failed. The social media account is already logged in.",
      account_already_and_implemented_online:
        "Login successful, not the current social media account, please search in the list",
      social_account_state: "Logging in..., please wait",
    },
    language: {
      zh_cn: "Chinese",
      en: "English",
    },
  },
};
